
import proxyComponent_address from '../../components/Paragraph/Address/proxy.vue'
import proxyComponent_image from '../../components/Paragraph/Image/proxy.vue'
import proxyComponent_issuu from '../../components/Paragraph/Issuu/proxy.vue'
import proxyComponent_teaser from '../../components/Paragraph/Teaser/proxy.vue'
import proxyComponent_text from '../../components/Paragraph/Text/proxy.vue'
import proxyComponent_title from '../../components/Paragraph/Title/proxy.vue'


const PROXY_COMPONENTS: Record<string, any> = {
  'address': proxyComponent_address,  
'image': proxyComponent_image,  
'issuu': proxyComponent_issuu,  
'teaser': proxyComponent_teaser,  
'text': proxyComponent_text,  
'title': proxyComponent_title
}

const DIFF_COMPONENTS: Record<string, any> = {
  
}

export function getBlokkliItemProxyComponent(bundle: string): any {
  return PROXY_COMPONENTS[bundle]
}

export function getBlokkliItemDiffComponent(bundle: string): any {
  return DIFF_COMPONENTS[bundle]
}
